import { AfterViewInit, Directive, ElementRef, OnDestroy } from "@angular/core";

@Directive({
    selector: "ngx-mat-select-search",
    standalone: true,
})
export class FixNgxMatSelectSearchDirective implements AfterViewInit, OnDestroy {
    private observer?: MutationObserver;

    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        this.setButtonType();

        // Use MutationObserver to handle dynamically added buttons (like the clear button)
        this.observer = new MutationObserver(() => {
            this.setButtonType();
        });

        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true,
        });
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }

    private setButtonType(): void {
        const buttons = this.el.nativeElement.querySelectorAll("button");
        buttons.forEach((button: HTMLButtonElement) => {
            if (button.getAttribute("type") !== "button") {
                button.setAttribute("type", "button");
            }
        });
    }
}
